import { render, staticRenderFns } from "./TransportDetails.vue?vue&type=template&id=9cd55602&scoped=true&"
import script from "./TransportDetails.vue?vue&type=script&lang=js&"
export * from "./TransportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd55602",
  null
  
)

export default component.exports